"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiInputAdornment = void 0;
exports.MuiInputAdornment = {
    styleOverrides: {
        root: {
            "&.MuiInputAdornment-root .MuiTypography-root": {
                fontSize: "1rem",
            },
        },
    },
};
//# sourceMappingURL=input-adornment.js.map